import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from 'antd';
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
function UIGridComponent(props) {
    return (_jsx(Flex, { gap: "middle", wrap: true, justify: "center", children: props.children }));
}
export default class UIGrid extends UIComponent {
    constructor(s) {
        super(s);
        resovleContent(this, s);
    }
    getComponent() {
        const props = {
            children: this.children.map((c) => c.getComponent()),
        };
        return _jsx(UIGridComponent, { ...props });
    }
}
//# sourceMappingURL=uiGrid.js.map